import { NavLink } from "react-router-dom";
import { HexLogo, Avatar } from "./primitives";
import { useTheme } from "./ThemeProvider";

const NAV = [
  { section: "Workspace" },
  { to: "/today", icon: "◉", label: "Today" },
  { to: "/board", icon: "▦", label: "Board" },
  { to: "/list", icon: "☰", label: "List" },
  { to: "/table", icon: "▤", label: "Table" },
  { section: "Service" },
  { to: "/tickets", icon: "✉", label: "Tickets" },
  { section: "Admin" },
  { to: "/admin", icon: "⚙", label: "Settings" },
] as const;

export function Sidebar({ tenantName, userName, userRole }: { tenantName: string; userName: string; userRole: string }) {
  const { branding } = useTheme();
  return (
    <aside
      className="glass-panel"
      style={{
        borderRight: "1px solid var(--border)",
        padding: "22px 16px",
        display: "flex",
        flexDirection: "column",
        gap: 6,
        position: "sticky",
        top: 0,
        height: "100vh",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 11, marginBottom: 26, padding: "0 6px" }}>
        <HexLogo glyph={branding?.logo_glyph} logoUrl={branding?.logo_url} />
        <div>
          <div style={{ fontSize: 15, fontWeight: 700, letterSpacing: "-0.2px", lineHeight: 1.15 }}>Action Center</div>
          <div
            style={{
              fontSize: 10.5,
              color: "var(--text-3)",
              letterSpacing: "0.4px",
              textTransform: "uppercase",
              marginTop: 2,
            }}
          >
            {branding?.display_name ?? tenantName}
          </div>
        </div>
      </div>

      {NAV.map((n, i) =>
        "section" in n ? (
          <div
            key={`s${i}`}
            style={{
              fontSize: 10,
              textTransform: "uppercase",
              letterSpacing: "0.9px",
              color: "var(--text-4)",
              margin: "16px 8px 6px",
              fontWeight: 600,
            }}
          >
            {n.section}
          </div>
        ) : (
          <NavLink key={n.to} to={n.to} className={({ isActive }) => `nav ${isActive ? "on" : ""}`}>
            <span aria-hidden="true" style={{ width: 16, textAlign: "center", fontSize: 14 }}>
              {n.icon}
            </span>
            {n.label}
          </NavLink>
        ),
      )}

      <div style={{ marginTop: "auto", paddingTop: 14, borderTop: "1px solid var(--border)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, padding: 6 }}>
          <Avatar name={userName} kind="lg" />
          <div>
            <div style={{ fontSize: 12.5, fontWeight: 600 }}>{userName}</div>
            <div style={{ fontSize: 10.5, color: "var(--text-3)" }}>{userRole}</div>
          </div>
        </div>
      </div>
    </aside>
  );
}
